/**
 * Check if document is defined - safe for SSR
 * Always call this as a function: isDocumentDefined()
 */
export const isDocumentDefined = () => typeof document !== "undefined";
